var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15.324 24.5",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon open-dollar",
    d: "M6.145 0v3.059H3.854A3.865 3.865 0 00.031 6.882v1.529a4.393 4.393 0 003.334 4.313l7.83 2.019a1.873 1.873 0 011.04 1.346v1.529a.757.757 0 01-.765.765H3.823a1.712 1.712 0 01-.765-.184v-2.875H0v3.059a2.874 2.874 0 001.345 2.385 4.319 4.319 0 002.478.673h2.294V24.5h3.059v-3.059h2.294a3.825 3.825 0 003.823-3.823v-1.529a4.393 4.393 0 00-3.334-4.313l-7.83-2.019a1.873 1.873 0 01-1.04-1.346V6.882a.757.757 0 01.765-.765h7.647a1.841 1.841 0 01.765.184v2.875h3.059V6.117a2.874 2.874 0 00-1.346-2.386 4.319 4.319 0 00-2.478-.673H9.207V0H6.145z"
  })));
}

export default SvgDollar;